export default {"src":"/_next/static/media/chevron-down.8b543013.svg","height":20,"width":32};